import { render } from "./AutoMLDetail.vue?vue&type=template&id=510e06ef&ts=true"
import script from "./AutoMLDetail.vue?vue&type=script&lang=ts"
export * from "./AutoMLDetail.vue?vue&type=script&lang=ts"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__